module.exports = __webpack_public_path__ + "files/46f289e5119901ac0a512931867b3584.png";